import 'css-chunkapp/javascript/shared/components/FlashSuccess/FlashSucess.module.scss';export default {
  "FlashSuccess": "FlashSucess-module__FlashSuccess___9KiGS",
  "content": "FlashSucess-module__content___YYYOh"
};